import React, { useState } from 'react';
import './Footer.css'
import { FaLinkedinIn } from "react-icons/fa6";
import { FiLinkedin } from "react-icons/fi";

import { BsTwitterX } from "react-icons/bs";
import { RiSendPlane2Fill } from "react-icons/ri";
import { toast } from 'react-toastify';
import Spinner from 'react-bootstrap/Spinner';
import PaperAirplaneImage from '../../../Images/paper_airplane.svg';
import { Image, Modal } from 'react-bootstrap';
import { GoDotFill } from "react-icons/go";
import LegalDoc from './LegalDoc';
import Email from '../../../components/Email';
import LogoWhite from '../../../Images/logo_white.png';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Calendly from '../../../components/Calendly';



const Footer: React.FC = () => {
  const [legalDocVisible, setLegalDocVisible] = useState(false);
  const [legalDocType, setLegalDocType] = useState('');
  const [email, setEmail] = useState<string>('');
  const [inprogress, setInprogress] = useState<boolean>(false);
  const [consultationModal, setConsultationModal] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  const sendEmail = async () => {
    try {
      setInprogress(true);
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (email == '') {
        throw new Error('Enter an email address');
      }
      else if (!emailRegex.test(email)) {
        throw new Error('Invalid email format');
      }
      const emailSender = new Email();

      // const success = await emailSender.makeSubscription(email);
      const success = await emailSender.makeEmail(email, email, 'New Subscription', [
        { head: 'Email', value: email },
      ]);

      if (success) {
        setEmail('');
        toast.success('You have successfully subscribed!', { position: toast.POSITION.TOP_RIGHT });
      } else {
        toast.error(`Subscription  Failed.`, { position: toast.POSITION.TOP_RIGHT });
      }

    } catch (error) {
      setInprogress(false);
      toast.error(`${error}`, { position: toast.POSITION.TOP_RIGHT });
    } finally {
      setInprogress(false);
    }
  };

  const scrollToTop = () => {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 200);
  };

  const checkUrl = (hash: string): boolean => {
    return new RegExp(`${hash}/$`).test(window.location.hash);
  };



  const toggleHash = (e: React.MouseEvent<HTMLAnchorElement>, hashName: string): void => {
    e.preventDefault();

    const base = `#${hashName}`;
    const target = checkUrl(base) ? base : `${base}/`;

    if (location.pathname !== '/') {
      navigate(`/${target}`);
    } else {
      window.location.hash = target;
    }
  };




  return (
    <footer className="footer text-light">
      <div className="container">
        <div className="row gy-4">

          {/* Logo and Description */}
          <div className="main-left">
            <div className="logo-block">
              {/* Replace this with your logo */}
              <img src={LogoWhite} alt="BreatheEV" className="mb-2" style={{ height: '24px' }} />
              <div className='breate-head'>BreatheEV</div>
            </div>
            <p className='breate-desc'>
              BreatheEV provides reservation-enabled EV charging solutions nationwide, helping
              property owners monetize parking assets with minimal investment.
            </p>
            <a target='_blank' href="https://www.linkedin.com/company/breathe-ev" className="text-light"> <FiLinkedin /></a>
          </div>

          <div className='main-right'>

            {/* Why BreatheEV */}
            <div className="right-menu">
              <h6 className="fw-bold mb-3">BreatheEV</h6>
              <ul className="list-unstyled small">
                {/* <li><Link onClick={scrollToTop}  to={'/'} >Home</Link></li> */}
                <li><Link onClick={scrollToTop} to={'/product'} >Product</Link></li>
                <li><Link onClick={scrollToTop} to={'/blogs'} >Blogs</Link></li>
                <li><Link onClick={scrollToTop} to={'/press'} >Press</Link></li>
                <li><Link to={"/#testimonials"} >Testimonials</Link></li>
                <li><Link onClick={scrollToTop} to={'/partner-with-us'} >Partner With Us</Link></li>
                {/* <li><a href="#" >Installation Process</a></li>
                  <li><a href="#" >FAQ</a></li> */}
              </ul>
            </div>


            {/* Solutions */}
            <div className="right-menu">
              <h6 className="fw-bold mb-3">Solutions</h6>
              <ul className="list-unstyled small">
                <li><Link to="/" onClick={(e) => toggleHash(e, 'multi-family')}>Multi-Family</Link></li>
                <li><Link to="/" onClick={(e) => toggleHash(e, 'commercial')}>Commercial</Link></li>
                <li><Link to="/" onClick={(e) => toggleHash(e, 'retail')}>Retail</Link></li>
                <li><Link to="/" onClick={(e) => toggleHash(e, 'hospitality')}>Hospitality</Link></li>
                <li><Link to="/" onClick={(e) => toggleHash(e, 'university')}>University</Link></li>
              </ul>
            </div>

            {/* Contact and Misc */}
            <div className="right-menu">
              <h6 className="fw-bold mb-3">Contact</h6>
              <ul className="list-unstyled small">
                <li><Link onClick={scrollToTop} to={'/'} >Home</Link></li>
                {/* <li><a href="#" >Careers</a></li>
                  <li><a href="#" >Download App</a></li>
                  <li><a href="#" >Support</a></li> */}
                <li><Link to="#" onClick={() => setConsultationModal(true)} >Schedule a Consultation</Link></li>
                {/* <li><a href="#" >Download Brochure </a></li> */}
                <li><Link to={'/partner-with-us#contact-sales'} className="text-decoration-none">Contact Sales</Link></li>
              </ul>
            </div>

          </div>
        </div>

        <hr className="border-secondary bottom-line" />
        {/* Footer Bottom */}
        <div className="bottom-block">
          <div>© {new Date().getFullYear()} BreatheEV. All rights reserved.</div>
          <div className="d-flex gap-3 mt-2 mt-md-0">
            <a href="#" onClick={() => { setLegalDocType('privacy-policy'); setLegalDocVisible(true); }} >Privacy Policy</a>
            <a href="#" onClick={() => { setLegalDocType('terms-of-service'); setLegalDocVisible(true); }} >Terms of Service</a>
            <a href="#" onClick={() => { setLegalDocType('cookie-policy'); setLegalDocVisible(true); }}>Cookie Policy</a>
          </div>


        </div>
      </div>
      <LegalDoc type={legalDocType} modalVisible={legalDocVisible} closeModal={() => { setLegalDocVisible(false); }} />



      <Calendly
        consultationModal={consultationModal}
        setConsultationModal={setConsultationModal}
      />

    </footer>
  );
};

export default Footer;
